import create from 'zustand';
import { CoreFactory } from '@/bridge/factory/CoreFactory';

export const sessionManager = CoreFactory.getSessionManager();

export const useSessionStore = create(sessionManager.store);
